import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import chat from './chat';
import calendar from './calendar';
import menu from './menu';
import snackbar from './snackbar';
import productReducer from './product';
import cartReducer from './cart';
import kanban from './kanban';
import invoice from './invoice';
import contacts from './accountly/contacts';
import transactions from './accountly/transactions';
import dashboard from './accountly/dashboard';
import expenses from './accountly/expenses';
import notes from './accountly/notes';
import reports from './accountly/reports';
import notifications from './accountly/notifications';
import reminders from './accountly/reminders';
import { RESET_ACCOUNTLY_STATE } from './accountly/resetAction';

export { RESET_ACCOUNTLY_STATE };

const appReducers = combineReducers({
  chat,
  calendar,
  menu,
  snackbar,
  contacts,
  transactions,
  dashboard,
  expenses,
  notes,
  reports,
  notifications,
  reminders,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'mantis-ts-'
    },
    cartReducer
  ),
  product: productReducer,
  kanban,
  invoice
});

const reducers = (state: ReturnType<typeof appReducers> | undefined, action: { type: string }) => {
  if (action.type === RESET_ACCOUNTLY_STATE && state) {
    state = {
      ...state,
      contacts: undefined,
      transactions: undefined,
      dashboard: undefined,
      expenses: undefined,
      notes: undefined,
      reports: undefined,
      notifications: undefined,
      reminders: undefined
    } as any;
  }
  return appReducers(state, action);
};

export default reducers;
